import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getOneCondition } from "../../../../../../../../store/actions";
import { useParams, useHistory } from "react-router-dom";
import View from "../../Repeated-Component/View";
import { useToast } from "@chakra-ui/react";

const ViewOneCondition = ({ getOneCondition, OneCondition, patient }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [condition, setCondition] = useState(null);
  const { medicalId } = useParams();
  const toast = useToast();
  let history = useHistory();

  useEffect(() => {
    if (medicalId && patient) {
      getOneCondition(medicalId, toast, history, patient.id);
    }
  }, []);

  useEffect(() => {
    const { loading, error, data } = OneCondition;
    setLoading(loading);
    setError(error);
    if (data) {
      setCondition(data);
    }
  }, [OneCondition]);
  const renderView = () => {
    return (
      <View
        loading={loading}
        error={error}
        headerText="View Condition"
        one={condition}
        history={history}
      />
    );
  };
  return renderView();
};

const mapStateToProps = (state) => {
  return {
    OneCondition: state.OneCondition,
  };
};
export default connect(mapStateToProps, { getOneCondition })(ViewOneCondition);
